module.exports = new __parcel__URL__("CreateWithRovoSpotlightAnimationDark.886221cf.gif").toString();